<script>
import Category from '@/components/Category.vue';
import Card from '@/components/Card.vue';
import Loader from '@/components/Loader.vue'

export default {
    data() {
        return {
            categoriesAndProperties: [],
            loader: true,
        }
    },
    created() {
        this.getHomePropertiesAndCategories();
    },
    methods: {
        searchingPropertie() {
            return window.open('https://wa.me/+5527999746179?text=Olá, José Guilherme. Vim através do site informar que estou buscando um imóvel, poderia me ajudar?', '_blank');
        },
        getHomePropertiesAndCategories() {
            this.loader = true;

            this.$axios.get('/properties/home_categories')
            .then(res => {
                this.categoriesAndProperties = res.data.data;
                this.loader = false;
            })
            .catch(err => {
                this.loader = false;
            });
        },
        callToWppPropertie(propertie) {
            return window.open(`https://wa.me/+5527999746179?text=Olá, José Guilherme. Tenho interesse no imóvel ${propertie.title} - ${propertie.location} - ${parseFloat(propertie.price).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`, '_blank');
        }
    },
    components: { Category, Card, Loader }
}
</script>

<template>
    <Loader v-if="loader" />

    <header class="bg-header">
        <section class="description-header">
            <h1>JOSÉ GUILHERME</h1>
            <h1>IMÓVEIS</h1>

            <div class="divider"></div>

            <h2>O imóvel que você procura,</h2>
            <h2>com a qualidade que você quer</h2>

            <p>Imóveis na região serrana do ES</p>

            <div class="divider"></div>

            <button @click="searchingPropertie">
                Estou buscando um imóvel
            </button>
        </section>

        <figure>
            <img src="../assets/img/mao.svg" alt="">
        </figure>
    </header>

    <section class="bg-principal-properties" v-if="!loader">
        <section class="bg-category">
            <Category v-for="(category, index) in categoriesAndProperties" :title="index == 'casas-apartamentos' ? 'Casas e Apartamentos' : index == 'chacaras' ? 'Chácaras' : index == 'sitios' ? 'Sitios' : index == 'lotes' ? 'Lotes' : index == 'terrenos' ? 'Terrenos' : index == 'pontos-comerciais' ? 'Pontos Comerciais' : 'Categoria'">
                <Card v-for="(propertie, index) in category" :propertieId="propertie.id" :title="propertie.title" :city="propertie.location" :price="propertie.price" :imageUrl="propertie.medias.length > 0 ? propertie.medias[0].url : false" @callToWpp="callToWppPropertie(propertie)" class="card"></Card>
            </Category>
        </section>
    </section>
</template>

<style scoped>
    .bg-header {
        width: 100%;
        height: auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 10px;
    }

    .description-header {
        margin-left: 50px;
    }

    .description-header h1 {
        font-size: 45px;
        font-weight: 750;
        color: #FF9F3F;
    }

    .description-header h2 {
        font-size: 26px;
        font-weight: 550;
        color: #474747;
    }

    .description-header p {
        font-size: 22px;
        font-weight: 400;
        color: #474747;
        margin-top: 10px;
    }

    .description-header button {
        background-color: #005F41;
        padding: 20px 0px;
        width: 420px;
        border: 1px solid #005F41;
        border-radius: 18px;
        font-size: 20px;
        font-weight: 550;
        color: white;
        cursor: pointer;
        margin-top: 10px;
        transition: .3s;
    }

    .description-header button:hover {
        background-color: #067652;
        transition: .3s;
    }

    .divider {
        margin: 20px 0px;
    }

    .bg-principal-properties {
        width: 100%;
        height: auto;
    }

    .bg-category {
        width: 100%;
    }

    .bg-category .card {
        margin-right: 20px;
    }

    @media screen and (max-width:768px) {
        .bg-header {
            display: block;
            margin-top: 30px;
        }

        .bg-header figure {
            display: none;
        }

        .description-header {
            margin-left: 0px;
            padding: 30px 20px;
        }

        .description-header h1 {
            font-size: 36px;
        }

        .description-header h2 {
            font-size: 22px;
            text-align: left;
        }

        .description-header p {
            font-size: 20px;
        }

        .description-header button {
            width: 100%;
        }
    }
</style>